import { useWindowSize } from '@vueuse/core'

export const useDetectMobile = (mobileWidth: number = 772) => {
  const { width } = useWindowSize()
  const isMobile = width.value < mobileWidth

  return { isMobile }
}